import {BaseSchemaDataModel, BaseSchemaModel} from "./base-schema-model";
import {SCHEMA_TYPE} from "./consts";

export class AnswerSchemaDataModel extends BaseSchemaDataModel {
  answer: String;
}

export class AnswerSchemaModel extends BaseSchemaModel {
  model: AnswerSchemaDataModel;

  constructor(model: AnswerSchemaDataModel) {
    super(SCHEMA_TYPE.answer);

    this.model = model;
  }

  get typeParams(): String {
    return this.type ? `"@type":"${this.type}"` : `` ;
  }

  get textParams(): String {
    //eslint-disable-next-line
    return this.model.answer ? `,"text":"${this.model.answer?.replaceAll('\"', '\\"')}"` : ``;
  }

  toString(): String {
    return `{${this.typeParams}${this.textParams}}`;
  }
}
